import styled, { keyframes } from 'styled-components'

const swing = keyframes`
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: -100% 0%;
  }
  100% {
    background-position: 0% 0%;
  }
`

const LogoGradient = styled.div`
  width: 100%;
  height: 144px;
  background-size: 200% auto;
  background-position: 0% 0%;
  background-repeat: repeat-x;
  -webkit-mask-image: url('/images/Logo.png');
  mask-image: url('/images/Logo.png');
  mask-size: contain;
  mask-position: center;
  mask-repeat: no-repeat;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ${swing} 5s linear infinite;
`

export default LogoGradient
